<template>
  <div id="user-role">
    <v-select
      v-if="editable"
      v-model="role"
      attach="#user-role"
      :hide-details="true"
      :disabled="disabled"
      append-icon="$faChevronDown"
      class="user-role-select"
      dense
      :menu-props="{'offsetY': true}"
      :items="['Watcher', 'Manager', 'Administrator']"
      @change="onChangeRole"
    />
    <span
      v-else-if="savedRole"
      class="user-role-overline"
    >
      {{ savedRole }}
    </span>
    <span
      v-else
      class="user-role-text"
    >
      Select an organization to view user role
    </span>
  </div>
</template>

<script>
  export default {
    name: 'UserRole',
    props: {
      org: Object,
      disabled: Boolean,
      editable: Boolean,
      savedRole: {
        validator (val) { return ['Administrator', 'Manager', 'Watcher', 'Account Owner'].includes(val) },
      },
    },
    data () {
      return {
        role: '',
      }
    },
    computed: {
      userId () {
        return this.$route.params.id
      },
    },
    watch: {
      savedRole () {
        this.initializeUserRole()
      },
    },
    created () {
      if (this.savedRole) this.initializeUserRole()
    },
    methods: {
      initializeUserRole () {
        this.role = this.savedRole
      },
      updateUserRole ({ orgId, orgName, role }) {
        this.$store.dispatch('Users/updateUserRole', { userId: this.userId, orgId, orgName, role })
      },
      onChangeRole (newRole) {
        const roleUpdateText = {
          Administrator: 'Administrators have access to every property in the organization, and can manage the permissions and settings of other users.',
          Manager: 'Managers can view and edit any properties to which they have been given permission by an Administrator.',
          Watcher: 'Watchers can view any properties to which they have been given permission by an Administrator, but cannot edit any settings.',
        }
        if (this.savedRole !== newRole) {
          this.$root.$confirm({
            title: 'Change User Role',
            text: roleUpdateText[newRole],
            icon: '$faUserTagLight',
            confirmText: 'Yes, change role',
            width: 410,
            minHeight: 500,
          })
            .then(() => {
              this.updateUserRole({ orgId: this.org.id, orgName: this.org.name, role: newRole })
            })
            .catch(() => this.initializeUserRole())
        }
      },
    },
  }
</script>

<style lang="scss">
  #user-role {
    .user-role-text {
      font-family: 'Degular', sans-serif;
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      line-height: 20px;
    }
    .user-role-select {
      max-width: 175px;
      & > .v-input__control > .v-input__slot::before {
        content: unset;
      }
      & .v-select__selection.v-select__selection--comma {
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 18px;
        letter-spacing: 1px;
        text-align: left;
        text-transform: uppercase;
      }
      .v-list-item__title {
        letter-spacing: 0.5px;
      }
    }
    .v-menu__content {
      top:auto !important;
      left: auto !important;
      .v-list {
        padding:0;
        margin-top:1px;
        .v-list-item {
          height: 40px;
          &:hover {
            background-color: $muted;
            color:white !important;
          }
          .v-list-item__content > .v-list-item__title {
            letter-spacing: 0.5px;
            font-size: 15px;
            line-height: 18px;
          }
        }
      }

    }
    .user-role-overline {
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 18px;
      letter-spacing: 1px;
      text-align: left;
      text-transform: uppercase;
    }
  }
</style>
